
    //数据 state
    const state = {
        selectScenesMsg  : false,   // 选中的场景数据
        selectSpritesMsg : false,   // 选中的元素
        TOOL             : false,   // 引擎接口
        spriteOperation  : 'add',    // add 新增素材 | swap 替换素材，替换素材遮罩层显示的情况下
        spriteBeforeSwap : null,
        isPreventClick   : false, // 是否显示防止高频点击lottie切换的遮罩
        bgOperation: 'add',
    }

    //获取数据 getters
    const getters = {
        SelectScenes_Msg  : state => state.selectScenesMsg,
        SelectSprites_Msg : state => state.selectSpritesMsg,
        TOOL              : state => state.TOOL,
        SpriteOperation   : state => state.spriteOperation,
        SpriteBeforeSwap  : state => state.spriteBeforeSwap,
        IsPreventClick    : state => state.isPreventClick,
        BgOperation:  state => state.bgOperation
    }

    //修改数据 mutations
    const mutations = {
        save_SelectScenesMsg (state, data){
            // selectScenesMsg
            state.selectScenesMsg = data ? data  : false;
        },
        save_SelectSpritesMsg (state, data){
            // selectScenesMsg
            state.selectSpritesMsg = data.length ? data  : false;
        },
        save_Tool(state, data){
            // selectScenesMsg
            state.TOOL = data ? data  : false;
        },
        save_SpriteOperation(state, data = 'add'){
          state.spriteOperation = data;
        },
        save_SpriteBeforeSwap(state, sprite) {
          state.spriteBeforeSwap = sprite
        },
        save_IsPreventClick(state, bool) {
          state.isPreventClick = bool
        },
        save_BgOperation(state, data = 'add'){
          state.bgOperation = data;
        },
    }

    export default {
        state,
        getters,
        mutations
    }



// WEBPACK FOOTER //
// ./src/store/modules/toolMsg.js